// extracted by mini-css-extract-plugin
export default {"previewContainer":"FieldRichText__previewContainer___fMGl5"};